import { cn } from '../../utils'

function LogoDarkSvg() {
  return (
    <svg
      width="352"
      height="71"
      className="h-full w-auto"
      viewBox="0 0 352 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        d="M8.64062 47.123V66.9881C8.64062 68.211 9.67558 68.7186 9.99756 68.8339C10.3195 68.9723 11.4005 69.2723 12.3664 68.3725L27.3944 53.9307C28.6741 52.701 29.9093 51.4083 30.8374 49.8958C31.2743 49.1847 31.4554 48.7842 31.4554 48.7842C32.3755 46.9154 32.3755 45.1158 31.4782 43.3161C30.1448 40.6398 26.7407 37.9172 21.6117 35.3331L12.8494 40.2245C10.2506 41.7011 8.64062 44.3083 8.64062 47.123Z"
        fill="white"
      />
      <path
        d="M0 2.94003V23.7742C0 26.3813 1.74793 28.6885 4.23183 29.4268C12.6953 31.8725 27.4375 37.1329 31.0024 44.8621C31.462 45.8772 31.7381 46.8694 31.8307 47.9076C34.1994 43.5931 35.2802 38.6326 34.7743 33.6029C34.0841 26.4736 30.3121 19.9903 24.4248 15.8604L3.42685 1.16347C3.05883 0.886606 2.62186 0.748169 2.1849 0.748169C1.81688 0.748169 1.4949 0.817388 1.14994 1.00197C0.459945 1.39419 0 2.10944 0 2.94003Z"
        fill="white"
      />
      <path
        opacity="0.8"
        d="M64.5349 47.123V66.9881C64.5349 68.211 63.5004 68.7186 63.178 68.8339C62.8564 68.9723 61.7747 69.2723 60.8092 68.3725L45.4314 53.5948C44.3847 52.5887 43.3851 51.5247 42.5966 50.3054C41.9721 49.3403 41.7204 48.7842 41.7204 48.7842C40.8003 46.9154 40.8003 45.1158 41.6968 43.3161C43.031 40.6398 46.4351 37.9172 51.5632 35.3331L60.3261 40.2245C62.9482 41.7011 64.5349 44.3083 64.5349 47.123Z"
        fill="white"
      />
      <path
        d="M73.1899 2.93832V23.7724C73.1899 26.3796 71.4416 28.6868 68.9575 29.4251C60.4943 31.8707 45.7524 37.1312 42.1875 44.8604C41.727 45.8756 41.4509 46.8677 41.3592 47.9059C38.9904 43.5915 37.9096 38.6309 38.4155 33.6012C39.1049 26.4718 42.8769 19.9886 48.7651 15.8587L69.7631 1.16176C70.1309 0.884889 70.5678 0.74646 71.0047 0.74646C71.3725 0.74646 71.6949 0.815678 72.0392 1.00026C72.7295 1.39248 73.1899 2.10772 73.1899 2.93832Z"
        fill="white"
      />
      <path
        d="M108.813 7.44067H116.852L135.482 50.5312H136.034L154.664 7.44067H162.564V57.1207H156.699V17.5837H156.147L139.07 57.1207H132.308L115.23 17.5837H114.678V57.1207H108.813V7.44067Z"
        fill="white"
      />
      <path
        d="M169.042 39.5602C169.042 27.6922 176.253 21.1372 186.948 21.1372C197.608 21.1372 204.853 27.6922 204.853 39.5602C204.853 51.3937 197.608 57.9487 186.948 57.9487C176.253 57.9487 169.042 51.3937 169.042 39.5602ZM175.183 39.5602C175.183 48.2542 179.91 52.9807 186.948 52.9807C193.951 52.9807 198.678 48.2542 198.678 39.5602C198.678 30.8317 193.951 26.1397 186.948 26.1397C179.91 26.1397 175.183 30.8317 175.183 39.5602Z"
        fill="white"
      />
      <path
        d="M210.652 21.9652H216.517V26.1742H217.069C218.277 23.6902 220.485 21.8272 225.763 21.8272H230.662V27.0712H225.901C219.312 27.0712 216.724 30.6937 216.724 37.8352V57.1207H210.652V21.9652Z"
        fill="white"
      />
      <path
        d="M235.333 70.9207V21.9652H241.267V26.8297H241.819C244.441 22.7587 248.719 21.1717 253.687 21.1717C262.829 21.1717 269.833 27.3817 269.833 39.5602C269.833 51.7042 262.829 57.9142 253.687 57.9142C248.822 57.9142 244.579 56.3617 241.957 52.4632H241.405V70.9207H235.333ZM241.198 39.5602C241.198 48.0817 245.752 52.8772 252.445 52.8772C259.172 52.8772 263.727 48.0817 263.727 39.5602C263.727 31.0042 259.172 26.2087 252.445 26.2087C245.752 26.2087 241.198 31.0042 241.198 39.5602Z"
        fill="white"
      />
      <path
        d="M275.647 7.44067H281.719V26.3122H282.271C284.789 22.5862 288.964 21.1717 293.897 21.1717C302.074 21.1717 307.249 25.3117 307.249 33.9022V57.1207H301.177V34.4887C301.177 28.7617 298.037 26.2432 292.552 26.2432C286.549 26.2432 281.719 29.7967 281.719 37.4902V57.1207H275.647V7.44067Z"
        fill="white"
      />
      <path
        d="M312.711 39.5602C312.711 27.6922 319.921 21.1372 330.616 21.1372C341.277 21.1372 348.522 27.6922 348.522 39.5602C348.522 51.3937 341.277 57.9487 330.616 57.9487C319.921 57.9487 312.711 51.3937 312.711 39.5602ZM318.852 39.5602C318.852 48.2542 323.578 52.9807 330.616 52.9807C337.62 52.9807 342.346 48.2542 342.346 39.5602C342.346 30.8317 337.62 26.1397 330.616 26.1397C323.578 26.1397 318.852 30.8317 318.852 39.5602Z"
        fill="white"
      />
    </svg>
  )
}

function LogoLightSvg() {
  return (
    <svg
      width="352"
      height="71"
      className="h-full w-auto"
      viewBox="0 0 352 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.64062 46.3716V66.2366C8.64062 67.4595 9.67558 67.9671 9.99756 68.0824C10.3195 68.2209 11.4005 68.5208 12.3664 67.621L27.3944 53.1792C28.6741 51.9495 29.9093 50.6568 30.8374 49.1443C31.2743 48.4333 31.4554 48.0328 31.4554 48.0328C32.3755 46.1639 32.3755 44.3643 31.4782 42.5646C30.1448 39.8883 26.7407 37.1658 21.6117 34.5817L12.8494 39.473C10.2506 40.9496 8.64062 43.5568 8.64062 46.3716Z"
        fill="#00378A"
      />
      <path
        d="M0 2.18857V23.0227C0 25.6299 1.74793 27.9371 4.23183 28.6754C12.6953 31.121 27.4375 36.3814 31.0024 44.1106C31.462 45.1258 31.7381 46.1179 31.8307 47.1561C34.1994 42.8417 35.2802 37.8811 34.7743 32.8514C34.0841 25.7221 30.3121 19.2388 24.4248 15.1089L3.42685 0.412008C3.05883 0.135141 2.62186 -0.0032959 2.1849 -0.0032959C1.81688 -0.0032959 1.4949 0.0659228 1.14994 0.250501C0.459945 0.642726 0 1.35798 0 2.18857Z"
        fill="#2470FF"
      />
      <path
        d="M64.5349 46.3716V66.2366C64.5349 67.4595 63.5004 67.9671 63.178 68.0824C62.8564 68.2209 61.7747 68.5208 60.8092 67.621L45.4314 52.8433C44.3847 51.8372 43.3851 50.7732 42.5966 49.5539C41.9721 48.5889 41.7204 48.0328 41.7204 48.0328C40.8003 46.1639 40.8003 44.3643 41.6968 42.5646C43.031 39.8883 46.4351 37.1658 51.5632 34.5817L60.3261 39.473C62.9482 40.9496 64.5349 43.5568 64.5349 46.3716Z"
        fill="#00378A"
      />
      <path
        d="M73.1899 2.18686V23.021C73.1899 25.6281 71.4416 27.9353 68.9575 28.6736C60.4943 31.1193 45.7524 36.3798 42.1875 44.1089C41.727 45.1241 41.4509 46.1162 41.3592 47.1545C38.9904 42.84 37.9096 37.8795 38.4155 32.8497C39.1049 25.7204 42.8769 19.2372 48.7651 15.1073L69.7631 0.410291C70.1309 0.133424 70.5678 -0.00500488 71.0047 -0.00500488C71.3725 -0.00500488 71.6949 0.0642135 72.0392 0.248791C72.7295 0.641017 73.1899 1.35626 73.1899 2.18686Z"
        fill="#2470FF"
      />
      <path
        d="M108.813 6.68921H116.852L135.482 49.7797H136.034L154.664 6.68921H162.564V56.3692H156.699V16.8322H156.147L139.07 56.3692H132.308L115.23 16.8322H114.678V56.3692H108.813V6.68921Z"
        fill="#0F0F0F"
      />
      <path
        d="M169.042 38.8087C169.042 26.9407 176.253 20.3857 186.948 20.3857C197.608 20.3857 204.853 26.9407 204.853 38.8087C204.853 50.6422 197.608 57.1972 186.948 57.1972C176.253 57.1972 169.042 50.6422 169.042 38.8087ZM175.183 38.8087C175.183 47.5027 179.91 52.2292 186.948 52.2292C193.951 52.2292 198.678 47.5027 198.678 38.8087C198.678 30.0802 193.951 25.3882 186.948 25.3882C179.91 25.3882 175.183 30.0802 175.183 38.8087Z"
        fill="#0F0F0F"
      />
      <path
        d="M210.652 21.2137H216.517V25.4227H217.069C218.277 22.9387 220.485 21.0757 225.763 21.0757H230.662V26.3197H225.901C219.312 26.3197 216.724 29.9422 216.724 37.0837V56.3692H210.652V21.2137Z"
        fill="#0F0F0F"
      />
      <path
        d="M235.333 70.1692V21.2137H241.267V26.0782H241.819C244.441 22.0072 248.719 20.4202 253.687 20.4202C262.829 20.4202 269.833 26.6302 269.833 38.8087C269.833 50.9527 262.829 57.1627 253.687 57.1627C248.822 57.1627 244.579 55.6102 241.957 51.7117H241.405V70.1692H235.333ZM241.198 38.8087C241.198 47.3302 245.752 52.1257 252.445 52.1257C259.172 52.1257 263.727 47.3302 263.727 38.8087C263.727 30.2527 259.172 25.4572 252.445 25.4572C245.752 25.4572 241.198 30.2527 241.198 38.8087Z"
        fill="#0F0F0F"
      />
      <path
        d="M275.647 6.68921H281.719V25.5607H282.271C284.789 21.8347 288.964 20.4202 293.897 20.4202C302.074 20.4202 307.249 24.5602 307.249 33.1507V56.3692H301.177V33.7372C301.177 28.0102 298.037 25.4917 292.552 25.4917C286.549 25.4917 281.719 29.0452 281.719 36.7387V56.3692H275.647V6.68921Z"
        fill="#0F0F0F"
      />
      <path
        d="M312.711 38.8087C312.711 26.9407 319.921 20.3857 330.616 20.3857C341.277 20.3857 348.522 26.9407 348.522 38.8087C348.522 50.6422 341.277 57.1972 330.616 57.1972C319.921 57.1972 312.711 50.6422 312.711 38.8087ZM318.852 38.8087C318.852 47.5027 323.578 52.2292 330.616 52.2292C337.62 52.2292 342.346 47.5027 342.346 38.8087C342.346 30.0802 337.62 25.3882 330.616 25.3882C323.578 25.3882 318.852 30.0802 318.852 38.8087Z"
        fill="#0F0F0F"
      />
    </svg>
  )
}

const LOGO_SIZE_CLASSNAME = {
  '4': 'h-4',
  '5': 'h-5',
  '6': 'h-6'
} as const

type MorphoLogoProps = {
  size?: keyof typeof LOGO_SIZE_CLASSNAME
  className?: string
}

export function MorphoLogo({ size = '5', className }: MorphoLogoProps) {
  // Theme is applied as a `.dark` / `.light` class on <html> by next-themes'
  // blocking script before first paint, so both variants are rendered and CSS
  // selects the right one. This keeps the logo correct in light mode at first
  // paint (the previous JS/`resolvedTheme` approach unconditionally showed the
  // white dark-logo until an effect ran) with no hydration mismatch.
  return (
    <div className={cn('relative w-auto', LOGO_SIZE_CLASSNAME[size], className)}>
      <div className="h-full dark:hidden">
        <LogoLightSvg />
      </div>
      <div className="hidden h-full dark:block">
        <LogoDarkSvg />
      </div>
    </div>
  )
}
